export default "__VITE_ASSET__vjctI_pj__"